import { ComparatorInvoiceType } from "layouts/invoices/utils/types"
import { InvoiceInfo } from "types/list-invoice"
import { SORTORDER, SortOrder } from "types/sort"
import { IFormInvoiceInput } from "layouts/invoices/filter"


export function invoiceSort(
    order: SortOrder,
    comparator: ComparatorInvoiceType
) {
    return (i1: InvoiceInfo, i2: InvoiceInfo) => {
        const res = comparator(i1, i2)

        return order === SORTORDER.DESC ? res : -res
    }
}

export const filterInvoices = (filterValues: IFormInvoiceInput) => {
    const { from, until, number, status } = filterValues
    const dayDurationInMilliseconds = 1000 * 60 * 60 * 24
    return (invoice: InvoiceInfo) => {
        const fromDateMatch = invoice.issueDateTimestamp >= from
        const untilDateMatch =
            invoice.issueDateTimestamp - dayDurationInMilliseconds <= until
        const numberMatch = invoice.number
            .toLowerCase()
            .includes(number.toLowerCase())
        const statusMatch =
            status === "Tous" ||
            (status === "Payée" && invoice.status === "PAID") ||
            (status === "Non payée" && invoice.status === "UNPAID") ||
            (status === "En attente de paiement" &&
                invoice.status === "IN_PROGRESS")
        return fromDateMatch && untilDateMatch && numberMatch && statusMatch
    }
}
